export let greyBtnCls = "bg-light-grey-100 text-black text-small w-xsmall h-xsmall round-border-s font-weight-bold";
export let redBtnCls = "bg-white text-danger text-small w-xsmall h-xsmall round-border-s font-weight-bold";
export let blueBtnCls = "btn-default bg-prime text-white text-small w-xsmall h-xsmall round-border-s font-weight-bold";
